import { useContext, useState } from "react";
import { Download } from "src/types";
import { RadioInputGroup, RadioInput } from "../radio-input";
import { StepActions } from "./step-actions";
import { StepperContext } from "./stepper";
import { hasKalturaMediaEntrySubtitles } from "src/api/videos.api";
import { getEntryIdFromSource } from "src/lib/utils/entry-id-from-source";
import { Spinner } from "../spinner";

interface DownloadSourceSelectProps {
  downloadItems: Download[];
  selectSource: (source: string, hasSubtitles: boolean) => void;
}

export function DownloadSourceSelect({ downloadItems, selectSource }: DownloadSourceSelectProps) {
  const { step, nextStep, cancel } = useContext(StepperContext);
  const [selectedSource, setSelectedSource] = useState("");
  const [loading, setLoading] = useState(false);

  const active = step === 1;

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (selectedSource) {
      setLoading(true);
      try {
        const entryId = getEntryIdFromSource(selectedSource);
        const hasSubtitles = await hasKalturaMediaEntrySubtitles(entryId);
        selectSource(selectedSource, hasSubtitles);
        nextStep();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="relative flex flex-col">
      <form className="mb-0" onSubmit={handleSubmit}>
        <RadioInputGroup label="Was möchten Sie herunterladen und ggf. individuell zuschneiden?" name="source" handleChange={setSelectedSource}>
          {downloadItems.map((downloadItem, index) => {
            return (
              <RadioInput
                key={`source-option-${index}`}
                value={downloadItem.url}
                checked={downloadItem.url === selectedSource}
                disabled={!active || loading}
              >
                {downloadItem.title}
              </RadioInput>
            );
          })}
        </RadioInputGroup>

        <StepActions
          cancelLabel="Abbrechen"
          cancelDisabled={!active}
          handleCancel={cancel}
          nextLabel="Weiter"
          nextDisabled={!active || !selectedSource || loading}
        />
      </form>
      {loading && (
        <div className="absolute inset-0 flex justify-center items-center bg-white motion-safe:animate-fadein">
          <Spinner />
        </div>
      )}
    </div>
  );
}
